import { setIsSocketConnected } from 'app/store/importCSV'
import { setIsListenSocketSchoolImport } from 'app/store/importExternalSource'
import { setShowProgressBar as setShowProgressBarOnCSVImport } from 'app/store/importCSV'
import { setShowProgressBar as setShowProgressBarOnSISImport } from 'app/store/importExternalSource'

export const hideProgressBars = (dispatch) => {
  dispatch(setShowProgressBarOnCSVImport(false))
  dispatch(setShowProgressBarOnSISImport(false))
}

export const disconnectSocket = (dispatch) => {
  dispatch(setIsListenSocketSchoolImport(false))
  dispatch(setIsSocketConnected(false))
}

export const hideImportProcessBarAndDisconnectSocket = (dispatch) => {
  // console.log(dispatch, 'dispatch')
  if (!dispatch) return

  hideProgressBars(dispatch)
  disconnectSocket(dispatch)
}
